export const costsPerModel: {
  [key: string]: {
    inputCostPerMillion: number;
    outputCostPerMillion: number;
    blendedCostPerMillion: number;
  };
} = {
  'Claude 3.5 Haiku': {
    inputCostPerMillion: 0.8,
    outputCostPerMillion: 4.0,
    blendedCostPerMillion: 4.8,
  },
  'Claude 3.5 Sonnet': {
    inputCostPerMillion: 3.0,
    outputCostPerMillion: 15.0,
    blendedCostPerMillion: 18.0,
  },
  'Claude 3.7 Sonnet': {
    inputCostPerMillion: 3.0,
    outputCostPerMillion: 15.0,
    blendedCostPerMillion: 18.0,
  },
  default: {
    inputCostPerMillion: 0.15,
    outputCostPerMillion: 0.6,
    blendedCostPerMillion: 0.26,
  },
};

export function getModelCosts(model: string) {
  return costsPerModel[model] || costsPerModel.default;
}

export function computeTicketCost(ticket: {
  ticket: {
    model: string;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}) {
  const { model, promptTokens, completionTokens, totalTokens } = ticket.ticket;
  const costs = getModelCosts(model);
  const inputCost = (promptTokens / 1_000_000) * costs.inputCostPerMillion;
  const outputCost =
    (completionTokens / 1_000_000) * costs.outputCostPerMillion;
  const blendedCost = (totalTokens / 1_000_000) * costs.blendedCostPerMillion;
  return { inputCost, outputCost, blendedCost };
}
